import { Route } from '@angular/router';
import {
  authenticatedGuard,
  canManageAnnouncementsGuard,
  canManageUsersGuard,
  canManageTenantsGuard,
  unauthenticatedGuard,
} from '@insolution/auth-data-access';
import { currentTenantGuard } from '@insolution/tenant-data-access';
import { availabilityGuard } from '@insolution/availability-data-access';
import { announcementRoutes } from '@insolution/announcement-feature';

export const appRoutes: Route[] = [
  {
    path: 'select-tenant',
    loadComponent: () =>
      import('@insolution/insolution-workshop-feature-layouts').then((m) => m.InsolutionWorkshopFeatureEntryLayout),
    children: [
      {
        path: '',
        loadComponent: () => import('@insolution/insolution-manager-feature-tenants').then((m) => m.SelectTenantPage),
        data: {
          title: 'common.select-tenant',
          breadcrumb: 'common.select-tenant',
        },
      },
    ],
    data: { appType: 'Workshop' },
    runGuardsAndResolvers: 'always',
    canActivate: [authenticatedGuard, availabilityGuard],
  },
  {
    path: 'availability',
    loadComponent: () =>
      import('@insolution/insolution-workshop-feature-layouts').then((m) => m.InsolutionWorkshopFeatureEntryLayout),
    loadChildren: () => import('@insolution/insolution-manager-feature-availability').then((m) => m.availabilityRoutes),
    data: { title: 'navigation.availability', breadcrumb: 'navigation.availability', appType: 'Workshop' },
    runGuardsAndResolvers: 'always',
    canActivate: [availabilityGuard],
  },
  {
    path: 'auth',
    loadComponent: () =>
      import('@insolution/insolution-workshop-feature-layouts').then((m) => m.InsolutionWorkshopFeatureEntryLayout),
    loadChildren: () => import('@insolution/insolution-manager-feature-auth').then((m) => m.authRoutes),
    data: { title: 'navigation.auth', breadcrumb: 'navigation.auth', appType: 'Workshop' },
    canActivate: [unauthenticatedGuard],
  },
  {
    path: '',
    loadComponent: () =>
      import('@insolution/insolution-workshop-feature-layouts').then((m) => m.InsolutionWorkshopFeatureDefaultLayout),
    children: [
      {
        path: 'orders',
        loadChildren: () => import('@insolution/insolution-workshop-feature-orders').then((m) => m.orderRoutes),
      },
      {
        path: 'users',
        loadChildren: () => import('@insolution/insolution-workshop-feature-users').then((m) => m.userRoutes),
        canActivate: [canManageUsersGuard],
      },
      {
        path: 'tenants',
        loadChildren: () => import('@insolution/insolution-workshop-feature-tenants').then((m) => m.tenantRoutes),
        canActivate: [canManageTenantsGuard],
      },
      {
        path: 'announcements',
        children: announcementRoutes,
        canActivate: [canManageAnnouncementsGuard],
      },
      { path: '', redirectTo: '/orders?sorting=due_date=asc', pathMatch: 'full' },
    ],
    data: { appType: 'Workshop' },
    runGuardsAndResolvers: 'always',
    canActivate: [authenticatedGuard, currentTenantGuard, availabilityGuard],
  },
  { path: '**', redirectTo: '/' },
];
